/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/jquery-match-height@0.7.2/dist/jquery.matchHeight.js
 * 
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
